<template>
    <div v-if="visible" class="o-alert o-alert--error mb-0 mt-0" role="alert" aria-live="assertive" aria-atomic="true">
        <div class="o-alert__icon">
            <svg class="svg-icon svg-circle-cross" aria-hidden="true" focusable="false">
                <use xlink:href="/wp-content/themes/ans/design-system/svg-icons/icon-sprite.svg#circle-cross"></use>
            </svg>
        </div>

        <h2 class="o-alert__title">Erreur</h2>

        <p>{{ message }}</p>

        <button type="button" class="btn btn--close btn--icon-only" aria-label="Masquer ce message" @click="dismiss">
            <svg class="svg-icon svg-close" aria-hidden="true" focusable="false">
                <use xlink:href="/wp-content/themes/ans/design-system/svg-icons/icon-sprite.svg#close"></use>
            </svg>
            <span class="sr-only">Masquer ce message</span>
        </button>
    </div>
</template>

<script>
export default {
    name: 'ErrorMessage',
    props: {
        message: {
            type: String,
            default: ''
        }
    },
    computed: {
        visible() {
            return !!this.message
        }
    },
    watch: {
        message(newValue) {
            if (newValue && typeof window !== 'undefined') {
                window.scrollTo({ top: 0, behavior: 'smooth' })
            }
        }
    },
    methods: {
        dismiss() {
            this.$emit('dismiss')
        }
    }
}
</script>
